var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSellerCancelBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "1b6iu1ir0a",
    d: "M0 0L16 0 16 16 0 16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-34 -504) translate(0 325) translate(16 53) translate(0 10) translate(0 101) translate(18 14) translate(0 1) translate(1 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lhko8ozi3b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1b6iu1ir0a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.974 14.045c-.171-.17-.198-.43-.02-.607l1.109-1.097-1.03-1.018c-.158-.157-.164-.424-.006-.581.165-.163.435-.157.594 0l1.029 1.019 1.108-1.097c.178-.177.442-.15.614.02.165.163.19.424.013.6L4.277 12.38l1.029 1.018c.158.157.158.418-.007.581-.158.157-.422.157-.58 0l-1.03-1.018-1.108 1.096c-.178.177-.442.15-.607-.013M3.666 16c1.997 0 3.676-1.653 3.676-3.638 0-1.994-1.66-3.637-3.676-3.637C1.661 8.725 0 10.368 0 12.362 0 14.366 1.66 16 3.666 16M9.572.97c1.11 0 1.894.821 1.922 1.772H7.65C7.687 1.792 8.471.97 9.572.97m4.198 1.773H12.54C12.5 1.274 11.233 0 9.572 0 7.92 0 6.652 1.274 6.615 2.742H5.374c-1.474 0-2.22.73-2.22 2.18v2.926c.167-.019.344-.028.512-.028.178 0 .355.01.523.028V4.976c0-.794.429-1.21 1.203-1.21h8.36c.765 0 1.212.416 1.212 1.21V12.4c0 .794-.447 1.2-1.026 1.2H8.07c-.093.37-.233.712-.42 1.025h6.307c1.296 0 2.043-.729 2.043-2.17V4.922c0-1.44-.756-2.179-2.23-2.179",
    mask: "url(#lhko8ozi3b)"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSellerCancelBlack);
export default __webpack_public_path__ + "static/media/ic_seller_cancel_black.26985b45917a550f9ba1d4a121ddc90d.svg";
export { ForwardRef as ReactComponent };